import * as ACTIONS from "../actions";

import Api from "../../services";

import cm from "./CommonFunction";

const CompletedRequest = {
  state: {
    COMPLETEDREQUEST: [],
    COMPLETEDREQUESTLOADING: false,
    COMPLETEDREQUESTERROR: null,
    DEPARTMENTS: [],
    TotalPages: 1,
    CONFIRMEDITLOADING: false,
    CONFIRMEDITERROR: null,
  },
  getters: {
    GETCOMPLETEDREQUESTLOADING: (state) => state.COMPLETEDREQUESTLOADING,
    GETCOMPLETEDREQUESTERROR: (state) => state.COMPLETEDREQUESTERROR,
    GETCOMPLETEDREQUEST: (state) => state.COMPLETEDREQUEST,
    GETCOMPLTEDTOTALPAGES: (state) => state.TotalPages,
    GETDETAPRTMENTSCOMPLETEDREQUEST: (state) => state.DEPARTMENTS,
    GETCONFIRMEDITLOADING: (state) => state.CONFIRMEDITLOADING,
    GETCONFIRMEDITERROR: (state) => state.CONFIRMEDITERROR,
  },
  actions: {
    [ACTIONS.COMPLETED_REQUEST_GET_ALL]: (context, query) => {
      context.commit(ACTIONS.COMPLETED_REQUEST_GET_ALL_PENDING);
      return new Promise((resolve, reject) => {
        Api.get("Request/GetAllCompletedRequest" + query, {
          headers: {
            token: context.rootState.LoginModule.token,
            cvx: cm.GetRefreshToken(),
          },
        })
          .then((res) => {
            commit.success(
              context,
              res,
              ACTIONS.COMPLETED_REQUEST_GET_ALL_SUCCESS,
              ACTIONS.COMPLETED_REQUEST_GET_ALL_ERROR,
              true,
            );
            return resolve(res);
          })
          .catch((err) => {
            commit.Error(context, err, ACTIONS.COMPLETED_REQUEST_GET_ALL_ERROR);
            return reject(err);
          });
      });
    },
    [ACTIONS.CONFIRM_EDIT_TRANSACTION]: (context, query) => {
      context.commit(ACTIONS.CONFIRM_EDIT_TRANSACTION_PENDING);
      return new Promise((resolve, reject) => {
        Api.get("Request/" + query, {
          headers: {
            token: context.rootState.LoginModule.token,
            cvx: cm.GetRefreshToken(),
          },
        })
          .then((res) => {
            commit.success(
              context,
              res,
              ACTIONS.CONFIRM_EDIT_TRANSACTION_SUCCESS,
              ACTIONS.CONFIRM_EDIT_TRANSACTION_ERROR,
              true,
            );
            return resolve(res);
          })
          .catch((err) => {
            commit.Error(context, err, ACTIONS.CONFIRM_EDIT_TRANSACTION_ERROR);
            return reject(err);
          });
      });
    },
  },
  mutations: {
    [ACTIONS.COMPLETED_REQUEST_GET_ALL_PENDING]: (state) => {
      state.COMPLETEDREQUESTLOADING = true;
      state.COMPLETEDREQUESTERROR = null;
    },
    [ACTIONS.COMPLETED_REQUEST_GET_ALL_SUCCESS]: (state, data) => {
      state.COMPLETEDREQUESTLOADING = false;
      state.COMPLETEDREQUESTERROR = null;
      state.COMPLETEDREQUEST = data.CompletedRequest;
      state.DEPARTMENTS = data.Departments;
      state.TotalPages = data.totalRecords;
    },
    [ACTIONS.COMPLETED_REQUEST_GET_ALL_ERROR]: (state, msg) => {
      state.COMPLETEDREQUESTLOADING = false;
      state.COMPLETEDREQUESTERROR = msg;
    },
    [ACTIONS.CONFIRM_EDIT_TRANSACTION_PENDING]: (state) => {
      state.CONFIRMEDITLOADING = true;
      state.CONFIRMEDITERROR = null;
    },
    [ACTIONS.CONFIRM_EDIT_TRANSACTION_SUCCESS]: (state) => {
      state.CONFIRMEDITLOADING = false;
      state.CONFIRMEDITERROR = null;
    },
    [ACTIONS.CONFIRM_EDIT_TRANSACTION_ERROR]: (state, msg) => {
      state.CONFIRMEDITLOADING = false;
      state.CONFIRMEDITERROR = msg;
    },
  },
};

const commit = {
  success: function(
    context,
    res,
    SuccessAction,
    ErrorAction,
    saveData = false,
  ) {
    var { commit } = context;
    var { data } = res;
    if (data && data.StatusCode == 200) {
      if (saveData) {
        commit(SuccessAction, data.ResponseData);
      } else {
        commit(SuccessAction);
      }
    } else if (
      data &&
      (data.StatusCode == 500 ||
        data.StatusCode == 403 ||
        data.StatusCode == 2 ||
        data.StatusCode == 429 ||
        data.StatusCode == 1 ||
        data.StatusCode == 406 ||
        data.StatusCode == 0)
    ) {
      commit(ErrorAction, data.StatusMessage);
    } else if (data && data.StatusCode == 450) {
      commit(ErrorAction, "Validation Failed");
    } else {
      commit(ErrorAction, "Unknown Error");
    }
  },
  Error: function(context, err, ActionName) {
    var { commit } = context;
    if (err.response) {
      commit(ActionName, "Error " + err.status);
    }
    if (err.request) {
      commit(ActionName, err.message);
    } else {
      // Something happened in setting up the request that triggered an Error

      commit(ActionName, "Error " + err.message);
    }
  },
};

export default CompletedRequest;
